var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateslots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2295 2.25V0.75M4.47949 2.25V0.75M1.29199 4.5H14.417M1.10449 6.033C1.10449 4.44675 1.10449 3.65325 1.43149 3.04725C1.72718 2.50673 2.18599 2.07338 2.74249 1.809C3.38449 1.5 4.22449 1.5 5.90449 1.5H9.80449C11.4845 1.5 12.3245 1.5 12.9665 1.809C13.5312 2.0805 13.9895 2.514 14.2775 3.0465C14.6045 3.654 14.6045 4.4475 14.6045 6.03375V9.71775C14.6045 11.304 14.6045 12.0975 14.2775 12.7035C13.9818 13.244 13.523 13.6774 12.9665 13.9418C12.3245 14.25 11.4845 14.25 9.80449 14.25H5.90449C4.22449 14.25 3.38449 14.25 2.74249 13.941C2.1861 13.6768 1.7273 13.2437 1.43149 12.7035C1.10449 12.096 1.10449 11.3025 1.10449 9.71625V6.033Z",
    stroke: "#155DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateslots);
export default __webpack_public_path__ + "static/media/Createslots.39ee4b91254579392ee781d4b672c3a8.svg";
export { ForwardRef as ReactComponent };